import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconButton } from '@projeccions-pdc/react-icon';
import Helpers from './helpers';
import './css/library.css';
import { libraryStyle } from './stylesParser';
import Tooltip from '@material-ui/core/Tooltip';
import FileService from '../../apiclients/FileService';
import BMF from 'browser-md5-file';

class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alreadyInLibrary: false,
        };

        this._bmf = new BMF();
    }

    getFileMd5 = (file) => {
        return new Promise((resolve, reject) => {
            this._bmf.md5(
                file,
                (err, md5) => {
                    if (err) {
                        console.log('hash err:', err);
                        reject(err);
                    }
                    resolve(md5);
                },
                progress => {
                    // console.log('progress number:', progress);
                },
            );
        });
    }

    async componentDidMount() {
        let file = this.props.element.file;
        let md5 = await this.getFileMd5(file);
        let coincidentFileIds = await FileService.findExistingFiles(file.size, md5);
        // console.log('coincidentFileIds', this.props.element.file.name, coincidentFileIds);
        let alreadyInLibrary;
        if (coincidentFileIds.length > 0) {
            alreadyInLibrary = true;
        } else {
            alreadyInLibrary = false;
        }
        this.setState({ alreadyInLibrary });
        this.props.onAlreadyInLibraryLoaded(this.props.fileID, alreadyInLibrary);
    }

    deleteFile = (event) => {
        event.preventDefault();
        this.props.handleDeleteFile(this.props.fileID);
    }

    shouldShowFilesizeWarning = () => {
        let size = this.props.element.file.size;
        if (this.props.element.file.type === 'video/mp4') {
            return size > (30 * 1024 * 1024);
        } else {
            return size > (5 * 1024 * 1024);
        }
    }

    render() {
        let icon = '';
        if (this.props.element.file.type === 'video/mp4') {
            icon = 'fa-video-camera';
        } else if (this.props.element.file.type === 'image/png') {
            icon = 'fa-file-image-o';
        } else if (this.props.element.file.type === 'image/jpeg') {
            icon = 'fa-file-image-o';
        } else {
            icon = 'fa-file-text-o';
        }

        return (
            <div style={{ verticalAlign: 'middle', borderBottom: '1px solid #000', marginBottom: '10px', paddingBottom: '10px' }} >
                <div className={libraryStyle.noMarginColumn} style={{ display: 'inline-block', width: '40px', verticalAlign: 'middle', position: 'relative' }} >
                    <Icon name={icon} size='30px' />
                </div>
                <div className={libraryStyle.noMarginColumn} style={{ display: 'inline-block', width: 'calc(50% - 30px)', verticalAlign: 'middle' }}>
                    {this.shouldShowFilesizeWarning() ?
                        <Tooltip title="File too large, in case of images and videos please consider optimizing quality">
                            <div style={{ display: 'inline-block' }}><Icon name='md-warning' primaryColor={'#cc3300'} /></div>
                        </Tooltip>
                        : ''}
                    {this.state.alreadyInLibrary === true ?
                        <Tooltip title="File already uploaded in the Library!">
                            <div style={{ display: 'inline-block' }}><Icon name='md-warning' primaryColor={'#4286f4'} /></div>
                        </Tooltip>
                        : ''}
                    <b>{this.props.element.file.name}</b>
                    <br />
                    {Helpers.humanFileSize(this.props.element.file.size)}
                </div>
                <div className={libraryStyle.noMarginColumn} style={{ display: 'inline-block', width: 'calc(50% - 30px)', verticalAlign: 'middle' }}>
                    {this.props.element.progress > 0 ?
                        < div style={{ backgroundColor: 'rgba(0,0,0,.1)', width: 'calc(100% - 10px)', borderRadius: '5px', marginLeft: '5px', marginRight: '5px', }}>
                            <div style={{
                                textAlign: 'center',
                                backgroundColor: '#62BE65',
                                opacity: '0.6',
                                width: this.props.element.progress + '%',
                                color: '#fff',
                                borderRadius: '5px',
                            }}>
                                {this.props.element.progress + '%'}
                            </div>
                        </div>
                        : ''}
                </div>
                <div className={libraryStyle.noMarginColumn} style={{ display: 'inline-block', width: '15px', verticalAlign: 'middle' }} floated='right'>
                    <IconButton name='fa-close' onClick={this.deleteFile} primaryColor='#000' secondaryColor='#9b9b9b' />
                </div>
            </div >
        );

    }
};
FileUpload.propTypes = {
    handleDeleteFile: PropTypes.func.isRequired,
    element: PropTypes.object.isRequired,
    fileID: PropTypes.string.isRequired,
    onAlreadyInLibraryLoaded: PropTypes.func.isRequired,
};

export default FileUpload;